export * from '../src/composites/wui-select/index.js';
//# sourceMappingURL=wui-select.js.map